<script setup lang="ts">

	import {useI18n} from 'vue-i18n';
  import {computed} from "vue";

  type AvailabilityWindow = Window & {
    syngentaTenant?: boolean;
  };

	const emit = defineEmits(['on-toggle-shopping-cart']);

	const {t} = useI18n();

	const toggleShoppingCart = () => emit('on-toggle-shopping-cart');

  const availabilityWindow = window as AvailabilityWindow;

  const isSyngentaTenant = computed(() => availabilityWindow.syngentaTenant === true);

</script>

<template>
	<div class="shoppingcart-footer">
		<button @click.prevent="toggleShoppingCart">
			{{ t('shoppingcart.close.button.text') }}
		</button>

		<div class="shoppingcart-row">
			<img v-if="!isSyngentaTenant" src="/assets/images/build/logo-dummenorange.png"
			     srcset="/assets/images/build/logo-dummenorange.svg"
			     alt="Dümmen Orange"
			     width="250"
			     height="44" />

      <img v-if="isSyngentaTenant" src="/assets/images/build/syngenta/logo-syngenta.png"
           srcset="/assets/images/build/syngenta/logo-syngenta.svg"
           alt="Syngenta Flowers"
           width="250"
           height="44" />
		</div>
	</div>
</template>
